'use strict';

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');

var SettingsMenuContent = function (_Component) {
  inherits(SettingsMenuContent, _Component);

  function SettingsMenuContent(player, options) {
    classCallCheck(this, SettingsMenuContent);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  SettingsMenuContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-settings-menu-content vjs-hidden'
    });
  };

  return SettingsMenuContent;
}(Component$1);

/**
 * @file settings-menu-item.js
 */

var MenuItem = videojs.getComponent('MenuItem');
var playbackRateMenuButton = videojs.getComponent('PlaybackRateMenuButton');
var component = videojs.getComponent('Component');
var playerItem = void 0;
var toTitleCase = function toTitleCase(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * The specific menu item type for selecting a setting
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @param {String=} entry
 * @extends MenuItem
 * @class SettingsMenuItem
 */
var self$1 = void 0;

var SettingsMenuItem = function (_MenuItem) {
    inherits(SettingsMenuItem, _MenuItem);

    function SettingsMenuItem(player, options, entry) {
        classCallCheck(this, SettingsMenuItem);

        var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

        self$1 = _this;
        _this.player = player;
        var subMenuName = toTitleCase(entry);
        playerItem = player;
        if (subMenuName === "PlaybackRateMenuButton") {
            _this.subMenu = player.getChild("controlBar").getChild(subMenuName);
        } else {
            var SubMenuComponent = void 0;
            if (subMenuName === "QualitySelector") {
                _this.subMenu = window._qualityButton;
                _this.subMenu.controlText_ = _this.player_.localize('quality');
                player.getChild("controlBar").removeChild("QualitySelector");
                var sub = _this.subMenu;
                _this.settingsSubMenuValueEl_.className += " quality-menu-value";
                player.on("qualityitemupadated", function () {
                    self$1.qualityItemUpdated(sub);
                });
            } else {
                SubMenuComponent = videojs.getComponent(subMenuName);

                if (!SubMenuComponent) {
                    throw new Error('Component ' + subMenuName + ' does not exist');
                }

                _this.subMenu = new SubMenuComponent(_this.player, options);
            }
        }
        var update = videojs.bind(_this, _this.update);
        // To update the sub menu value on click, setTimeout is needed because
        // updating the value is not instant
        var updateAfterTimeout = function updateAfterTimeout() {
            setTimeout(update, 0);
        };
        if (_this.subMenu && _this.subMenu.menu) {
            for (var _iterator = _this.subMenu.menu.children(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var item = _ref;

                if (!(item instanceof component)) {
                    continue;
                }
                item.on('click', updateAfterTimeout);
            }
        }
        player.on("ratechange", function () {
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        });

        _this.update();
        return _this;
    }

    /**
     * Create the component's DOM element
     *
     * @return {Element}
     * @method createEl
     */


    SettingsMenuItem.prototype.createEl = function createEl() {
        // Hide this component by default
        var el = videojs.dom.createEl('li', {
            className: 'vjs-menu-item'
        });

        this.settingsSubMenuTitleEl_ = videojs.dom.createEl('div', {
            className: 'vjs-settings-sub-menu-title'
        });

        el.appendChild(this.settingsSubMenuTitleEl_);

        this.settingsSubMenuValueEl_ = videojs.dom.createEl('div', {
            className: 'vjs-settings-sub-menu-value'
        });

        el.appendChild(this.settingsSubMenuValueEl_);

        // el.appendChild(this.settingsSubMenuEl_);

        return el;
    };

    /**
     * Handle click on menu item
     *
     * @method handleClick
     */


    SettingsMenuItem.prototype.handleClick = function handleClick() {
        // Remove open class to ensure only the open submenu gets this class
        videojs.dom.removeClass(this.el_, 'open');

        _MenuItem.prototype.handleClick.call(this);

        // Wether to add or remove vjs-hidden class on the settingsSubMenuEl element
        if (videojs.dom.hasClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden')) {
            videojs.dom.removeClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        } else {
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        }
        if (this.settingsSubMenuEl_ instanceof playbackRateMenuButton) document.querySelector('.uep-setting-menu .vjs-menu').classList.remove('vjs-lock-showing');

        if (this.settingsSubMenuEl_ && videojs.dom.hasClass(this.settingsSubMenuEl_, 'vjs-hidden')) {
            videojs.dom.removeClass(this.settingsSubMenuEl_, 'vjs-hidden');
        } else {
            videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
        }
    };

    /**
     * Update the sub menus
     *
     * @method update
     */


    SettingsMenuItem.prototype.update = function update() {
        if (this.subMenu) {
            var player = this.player;
            var classQuality = this.subMenu.name_ === "QualitySelector" ? " vjs-settings-sub-menu quality-content vjs-hidden" : "vjs-settings-sub-menu vjs-hidden";
            classQuality = "vjs-" + this.subMenu.name_ + " " + classQuality;

            //append to component.
            if (this.settingsSubMenuEl_ === undefined) {
                if (this.subMenu.menu) {
                    this.settingsSubMenuTitleEl_.innerHTML = player.localize(this.subMenu.controlText_) + ' :';
                    this.settingsSubMenuEl_ = videojs.dom.createEl('div', {
                        className: classQuality
                    });
                    playerItem.getChild("SettingsMenuContent").el().appendChild(this.settingsSubMenuEl_);
                    this.settingsSubMenuEl_.appendChild(this.subMenu.menu.el_);
                } else {
                    this.settingsSubMenuEl_ = videojs.dom.createEl('div', {
                        className: classQuality
                    });
                    this.settingsSubMenuTitleEl_.innerHTML = this.subMenu.controlText_;
                    playerItem.getChild("SettingsMenuContent").el().appendChild(this.settingsSubMenuEl_);
                    this.settingsSubMenuEl_.appendChild(this.subMenu.el_);
                }
            }
            // Playback rate menu button doesn't get a vjs-selected class
            // or sets options_['selected'] on the selected playback rate.
            // Thus we get the submenu value based on the labelEl of playbackRateMenuButton
            if (this.subMenu instanceof playbackRateMenuButton) {
                this.settingsSubMenuValueEl_.innerHTML = this.subMenu.labelEl_.innerHTML;
            } else {
                // Loop trough the submenu items to find the selected child
                if (this.subMenu.menu) {
                    for (var _iterator2 = this.subMenu.menu.children_, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                        var _ref2;

                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }

                        var subMenuItem = _ref2;

                        if (!(subMenuItem instanceof component)) {
                            continue;
                        }
                        // Set submenu value based on what item is selected
                        if (subMenuItem.options_.selected || subMenuItem.hasClass('vjs-selected')) {
                            this.settingsSubMenuValueEl_.innerHTML = subMenuItem.options_.label;
                        }
                    }
                }
            }
        }
    };

    /**
     * Hide the sub menu
     */


    SettingsMenuItem.prototype.hideSubMenu = function hideSubMenu() {
        if (videojs.dom.hasClass(this.el_, 'open')) {
            if (this.settingsSubMenuEl_) {
                videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
            }
            videojs.dom.removeClass(this.el_, 'open');
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        }
    };

    SettingsMenuItem.prototype.updateQualityValue = function updateQualityValue(item, componentQuality) {
        var player = this.player;
        if (item) {
            if (item.textContent.indexOf("Auto") > -1) {
                item.children[1].innerText = "";
            }
            player.trigger("changequalityhls", { height: item.textContent.indexOf("Auto") > -1 ? "auto" : parseInt(item.textContent) });

            document.querySelector(".quality-menu-value").innerHTML = item.textContent;

            var children = componentQuality.getElementsByClassName("vjs-selected");
            for (var _iterator3 = children, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var _item = _ref3;

                _item.className = "vjs-menu-item";
            }
            item.className += " vjs-selected";
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        } else {
            for (var _iterator4 = window._qualityButton.items, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref4;

                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }

                var subMenuItem = _ref4;

                if (!(subMenuItem instanceof component)) {
                    continue;
                }
                // Set submenu value based on what item is selected
                if (subMenuItem.options_.selected || subMenuItem.hasClass('vjs-selected')) {
                    document.querySelector(".quality-menu-value").innerHTML = subMenuItem.options_.label;
                }
            }
        }
    };

    SettingsMenuItem.prototype.qualityItemUpdated = function qualityItemUpdated(subMenu) {
        var qualityComponent = document.querySelector(".quality-content");
        qualityComponent.innerHTML = window._qualityButton.menu.el_.outerHTML;
        subMenu.menu.children_ = window._qualityButton.items;
        self$1.updateQualityValue();
        var children = qualityComponent.getElementsByClassName("vjs-menu-item");
        for (var _iterator5 = children, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref5 = _iterator5[_i5++];
            } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref5 = _i5.value;
            }

            var item = _ref5;

            item.addEventListener('click', function (e) {
                self$1.updateQualityValue(e.currentTarget, qualityComponent);
            });
        }
    };

    return SettingsMenuItem;
}(MenuItem);

SettingsMenuItem.prototype.contentElType = 'button';

videojs.registerComponent('SettingsMenuItem', SettingsMenuItem);

/**
 * @file settings-menu-button.js
 */
var MenuButton = videojs.getComponent('MenuButton');
var Menu = videojs.getComponent('Menu');
var Component = videojs.getComponent('Component');

/**
 * The component for controlling the settings menu
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends MenuButton
 * @class SettingsMenuButton
 */

var SettingsMenuButton = function (_MenuButton) {
  inherits(SettingsMenuButton, _MenuButton);

  function SettingsMenuButton(player, options) {
    classCallCheck(this, SettingsMenuButton);

    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));

    _this.addClass('uep-setting-menu');
    _this.options = options;

    _this.el_.setAttribute('aria-label', player.localize('settings'));

    _this.controlText = player.localize('settings');
    _this.showed = false;
    if (_this.el_.children[0]) {
      _this.el_.children[0].addEventListener("mouseover", videojs.bind(_this, _this.showMenu));
    }
    _this.on('click', videojs.bind(_this, _this.hideChildren));
    _this.on('mouseover', videojs.bind(_this, _this.hideChildren));
    return _this;
  }

  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  SettingsMenuButton.prototype.handleClick = function handleClick(event) {
    // When you click the button it adds focus, which will show the menu.
    // So we'll remove focus when the mouse leaves the button. Focus is needed
    // for tab navigation.

    this.one(this.menu.contentEl(), 'mouseleave', videojs.bind(this, function (e) {
      this.unpressButton();
      this.el_.blur();
    }));
    if (this.buttonPressed_) {
      document.querySelector('.vjs-settings-menu-content').classList.add('vjs-hidden');
      var sub_menus = document.querySelectorAll('.vjs-settings-sub-menu');
      for (var _iterator = sub_menus, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var sub_menu = _ref;

        sub_menu.classList.add('vjs-hidden');
      }
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };
  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */


  SettingsMenuButton.prototype.buildCSSClass = function buildCSSClass() {
    // vjs-icon-cog can be removed when the settings menu is integrated in video.js
    return 'vjs-settings-menu vjs-icon-cog ' + _MenuButton.prototype.buildCSSClass.call(this);
  };

  /**
   * Create the settings menu
   *
   * @return {Menu} Menu object populated with items
   * @method createMenu
   */

  SettingsMenuButton.prototype.createMenu = function createMenu() {
    var menu = new Menu(this.player());
    var entries = this.options_.entries;

    if (entries) {

      var openSubMenu = function openSubMenu() {

        if (videojs.dom.hasClass(this.el_, 'open')) {
          videojs.dom.removeClass(this.el_, 'open');
        } else {
          videojs.dom.addClass(this.el_, 'open');
        }
        document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "none";
      };

      for (var _iterator2 = entries, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var entry = _ref2;

        if (entry === "qualitySelector" && window._qualityButton === undefined) {
          continue;
        }
        var settingsMenuItem = new SettingsMenuItem(this.player(), this.options_, entry);

        menu.addChild(settingsMenuItem);

        // Hide children to avoid sub menus stacking on top of each other
        // or having multiple menus open
        settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));

        // Wether to add or remove selected class on the settings sub menu element
        settingsMenuItem.on('click', openSubMenu);
        /*else
        {
          settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));
           console.log("--------------------");
          settingsMenuItem.on('click', videojs.bind(this, this.openHotKey));
         }*/
      }
    }

    return menu;
  };

  /*
   * Hide all the sub menus
   */


  SettingsMenuButton.prototype.hideChildren = function hideChildren() {
    videojs.dom.removeClass(window._defaultMenuComponent.el_, "hot-key-show");
    for (var _iterator3 = this.menu.children(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var menuChild = _ref3;

      menuChild.hideSubMenu();
    }
  };

  SettingsMenuButton.prototype.openHotKey = function openHotKey() {

    var helpComponet = videojs.getComponent("ModalHotKeyOverlay");
    if (!helpComponet) {
      throw new Error('Component ' + helpComponet + ' does not exist');
    }
    this.player().getChild('ModalHotKeyOverlay').open();
    document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "none";
  };

  SettingsMenuButton.prototype.showMenu = function showMenu() {
    document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "block";
  };

  SettingsMenuButton.prototype.hideMenu = function hideMenu() {
    document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "none";
  };
  /*
   * Hide all the sub menus
   */

  return SettingsMenuButton;
}(MenuButton);

Component.registerComponent('SettingsMenuButton', SettingsMenuButton);

var ClickableComponent = videojs.getComponent('ClickableComponent');

var informationMenu = function (_ClickableComponent) {
  inherits(informationMenu, _ClickableComponent);

  function informationMenu(player, options) {
    classCallCheck(this, informationMenu);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.name_ = "informationMenu";
    _this.controlText_ = _this.player_.localize('information');
    _this.title = options.info.title;
    _this.description = options.info.description;
    _this._content();
    return _this;
  }

  informationMenu.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-menu vjs-information-menu',
      controlText: this.player_.localize('information'),
      name: "informationMenu"
    });
  };

  informationMenu.prototype._content = function _content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-menu-content" role="menu">\n      <div class="vjs-menu-title">' + this.player_.localize('information') + '</div>\n      <div id="DescriptionBox" style="">\n      <div id="DescriptionTitle" class="TextTitle" style="left: 136px;text-align: center"><p>\n      ' + this.title + '</p></div><div id="DescriptionDesc" class="TextDescription" style="left: 136px;"><p>' + this.description + '</p></div></div>\n      </div>';
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  return informationMenu;
}(ClickableComponent);

var ClickableComponent$1 = videojs.getComponent('ClickableComponent');

var helpMenu = function (_ClickableComponent) {
    inherits(helpMenu, _ClickableComponent);

    function helpMenu(player, options) {
        classCallCheck(this, helpMenu);

        var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

        _this.name_ = "helpMenu";
        _this.controlText_ = _this.player_.localize('help');
        _this._content();
        return _this;
    }

    helpMenu.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-menu vjs-help-menu',
            controlText: this.player_.localize('help'),
            name: "helpMenu"
        });
    };

    helpMenu.prototype._content = function _content() {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = '<div id="HelpTooltip vjs-menu-content" class="Menu">\n                    <div class="vjs-menu-title">' + this.player_.localize('shortcutListe') + '</div>\n                <table id="ListOfShortcut" style="width: 100%; padding: 3px;">\n                    <tr class="HeaderHelpMenu">\n                        <th id="TextHelpKey" class="LeftTable">' + this.player_.localize('shortcut') + '</th>\n                        <th id="TextHelpDesc" class="RightTable">' + this.player_.localize('functions') + '</th>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpArrowMaj" class="LeftTable">\n                            <center>' + this.player_.localize('space') + '</center>\n                        </td>\n                        <td id="TextHelpDescArrowMaj" class="RightTable">\n                            <center>' + this.player_.localize('play_pause') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyLeft" class="LeftTable">\n                            <center>' + this.player_.localize('f_ctrl_enter') + '</center>\n                        </td>\n                        <td id="TextHelpDescLeft" class="RightTable">\n                            <center>' + this.player_.localize('fullscreen') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyLeftMaj" class="LeftTable">\n                            <center>' + this.player_.localize('arrow_up') + '</center>\n                        </td>\n                        <td id="TextHelpDescLeftMaj" class="RightTable">\n                            <center>' + this.player_.localize('volumeHelp') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyHaut" class="LeftTable">\n                            <center>' + this.player_.localize('arrow_left') + '</center>\n                        </td>\n                        <td id="TextHelpDescHaut" class="RightTable">\n                            <center>' + this.player_.localize('forward') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyBas" class="LeftTable">\n                            <center>' + this.player_.localize('arrow_maj') + '</center>\n                        </td>\n                        <td id="TextHelpDescBas" class="RightTable">\n                            <center>' + this.player_.localize('fast_forward') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyBas" class="LeftTable">\n                            <center>O</center>\n                        </td>\n                        <td id="TextHelpDescBas" class="RightTable">\n                            <center>' + this.player_.localize('settings_window') + '</center>\n                        </td>\n                    </tr>\n                </table>\n            </div>';
        videojs.dom.appendContent(this.el(), wrapper.firstChild);
    };

    return helpMenu;
}(ClickableComponent$1);

var ClickableComponent$2 = videojs.getComponent('ClickableComponent');

var languageMenu = function (_ClickableComponent) {
    inherits(languageMenu, _ClickableComponent);

    function languageMenu(player, options) {
        classCallCheck(this, languageMenu);

        var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

        _this.name_ = "languageMenu";
        _this.controlText_ = _this.player_.localize('language');
        _this._content();
        return _this;
    }

    languageMenu.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-menu vjs-language-menu',
            controlText: this.player_.localize('language'),
            name: "languageMenu"
        });
    };

    languageMenu.prototype._content = function _content() {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = '<div class="vjs-menu-content" role="menu">\n      <div class="vjs-menu-title">' + this.player_.localize('language') + '</div>\n      <div id="LangMenu" class="vjs-menu-text Menu" style="width: 207px;">\n      <table style="width: 100%;">\n      <tr class="ContentMenu"><td id="langFrancais" class="selected left" onclick="utils()._updateLang(\'fr\')">' + this.player_.localize('fr') + '</td></tr>\n      <tr class="ContentMenu"><td id="langEnglish" class="selectable" onclick="utils()._updateLang(\'en\')">' + this.player_.localize('en') + '</td></tr></table></div>\n      </div>\n';
        videojs.dom.appendContent(this.el(), wrapper.firstChild);
    };

    return languageMenu;
}(ClickableComponent$2);

var ClickableComponent$3 = videojs.getComponent('ClickableComponent');

var aboutMenu = function (_ClickableComponent) {
  inherits(aboutMenu, _ClickableComponent);

  function aboutMenu(player, options) {
    classCallCheck(this, aboutMenu);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.name_ = "aboutMenu";

    _this.controlText_ = player.localize('aboutMenu');
    _this.player = player;
    _this._content();
    player.on('touchend', function (e) {
      if (e.target == document.querySelector("#href_empreinte")) {
        document.location.href = '//www.empreinte.com';
      }
    });
    return _this;
  }

  aboutMenu.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-menu vjs-about-menu',
      controlText: this.player_.localize('aboutMenu'),
      name: "aboutMenu"
    });
  };

  aboutMenu.prototype._content = function _content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-menu-content" role="menu">\n      <div class="vjs-menu-title">' + this.player.localize('aboutMenu') + '</div>\n      <div id="AboutMenu" class="vjs-menu-text Menu" style="width: 209px;"><p id="TextAboutContent">UEP version 2.0.0<br>Universal Empreinte Player<br><a id="href_empreinte" target="_blank" href="//www.empreinte.com">www.empreinte.com</a><a></a></p></div>\n      </div>';
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  return aboutMenu;
}(ClickableComponent$3);

function utils() {

  return utils.prototype = {
    _updateLang: function _updateLang(lang) {
      videojs.getAllPlayers()[0].language(lang);
    }
  };
}

window.utils = utils;
// Default options for the plugin.
var defaults = {};

videojs.addLanguage('fr', {
  "settings": "Paramètres",
  "aboutMenu": "A propos",
  "help": "Aide",
  "shortcutListe": "Liste des raccourcis clavier :",
  "functions": "Fonctions",
  "space": "Espace",
  "play_pause": "Lecture / Pause",
  "f_ctrl_enter": "F ou CTRL + Entrer",
  "arrow_up": "Flèche haut/bas",
  "arrow_left": "Flèche gauche/droite",
  "forward": "Avance / Recule",
  "fast_forward": "Avance / Recule rapide",
  "arrow_maj": "Flèche G./D. + MAJ",
  "volumeHelp": "Régler le volume",
  "fullscreen": "Plein écran",
  "information": "Information",
  "settings_window": "Fenêtre d'options",
  "language": "Langue",
  "quality": "Qualité",
  "shortcut": "Raccourcis"
});
videojs.addLanguage('en', {
  "settings": "Settings",
  "aboutMenu": "About",
  "help": "Help",
  "shortcutListe": "Keyboard shortcut list: ",
  "functions": "Functions",
  "space": "Space",
  "play_pause": "Play / Pause",
  "f_ctrl_enter": "F or CTRL + Enter",
  "arrow_up": "Arrow up / down",
  "arrow_left": "Arrow left / right",
  "forward": "Forward / Backward",
  "fast_forward": "Fast forward / backward",
  "arrow_maj": "Arrow L./R. + MAJ",
  "volumeHelp": "Set volume",
  "fullscreen": "Fullscreen",
  "settings_window": "Settings window",
  "information": "Information",
  "language": "Language",
  "quality": "Quality",
  "shortcut": "Shortcuts"
});

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  console.log(player.localize('aboutMenu'));
  player.addClass('vjs-videojs-default');
  player.addChild("SettingsMenuContent", SettingsMenuContent);
  // options.entries = ['informationMenu','helpMenu','languageMenu','playbackRateMenuButton','aboutMenu'];
  var setting = new SettingsMenuButton(player, options);
  var child = player.getChild("controlBar").addChild(setting, SettingsMenuButton);
  window._defaultMenuComponent = child;
  document.addEventListener('click', function () {
    try {
      videojs.dom.addClass(player.getChild("SettingsMenuContent").el(), 'vjs-hidden');
      var sub_menus = document.querySelectorAll('.vjs-settings-sub-menu');
      for (var _iterator = sub_menus, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var sub_menu = _ref;

        sub_menu.classList.add('vjs-hidden');
      }
    } catch (e) {
      console.log(e);
    }
  });
  document.addEventListener('touchstart', function () {
    videojs.dom.addClass(player.getChild("SettingsMenuContent").el(), 'vjs-hidden');
    var sub_menus = document.querySelectorAll('.vjs-settings-sub-menu');
    for (var _iterator2 = sub_menus, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var sub_menu = _ref2;

      sub_menu.classList.add('vjs-hidden');
    }
  });
};
videojs.registerComponent('SettingsMenuContent', SettingsMenuContent);
videojs.registerComponent('settingsMenuButton', SettingsMenuButton);
videojs.registerComponent('informationMenu', informationMenu);
videojs.registerComponent('helpMenu', helpMenu);
videojs.registerComponent('aboutMenu', aboutMenu);
videojs.registerComponent('languageMenu', languageMenu);
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function default
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var defaultSkin = function defaultSkin(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('defaultSkin', defaultSkin);

// Include the version number.
defaultSkin.VERSION = version;

module.exports = defaultSkin;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_default/dist/videojs-default.cjs.js
// module id = 809
// module chunks = 0